module.exports = __webpack_public_path__ + "img/barcode.e9ddfa1c.svg";